import styled, { CSSObject } from '@emotion/styled'
import { calcRem, themedValue } from '../..'
import { getChipCSS } from '../helpers/getChipCSS'
import { ChipVariant } from './Chip'

export interface StyledChipProps {
    iconSide?: 'left' | 'right'
    variant: ChipVariant
    buttonType?: string
}

export const StyledChip = styled('button')<StyledChipProps>(
    ({ theme, variant, buttonType, iconSide }) => {
        const iconRight = iconSide === 'right'

        const sharedStyling: CSSObject = {
            flexDirection: iconRight ? 'row-reverse' : 'row',
            margin: theme.margins.xs,
            height: calcRem(32),
            padding: calcRem(8, 10),
            border: '0px',
            borderRadius: calcRem(24),

            fontSize: themedValue(theme, {
                thewest: calcRem(16),
                perthnow: calcRem(16),
                sevennews: calcRem(16),
            }),
            fontFamily: themedValue(theme, {
                thewest: theme.fonts.sansSerif,
                perthnow: theme.fonts.sansSerif,
                sevennews: theme.fonts.headingAlternative,
            }),
            fontWeight: themedValue(theme, {
                sevennews: 400,
                fallback: 500,
            }),

            display: 'flex',

            '& > svg': {
                width: calcRem(14),
                height: calcRem(14),
            },

            '& > span': {
                position: 'relative',
                bottom: themedValue(theme, {
                    thewest: 2,
                    fallback: 0,
                }),
                paddingLeft: iconRight ? 0 : calcRem(4),
                paddingRight: iconRight ? calcRem(4) : 0,
            },
        }

        /* Variant specific styling found in getChipCSS */
        return getChipCSS(variant, sharedStyling, theme, buttonType)
    },
)

export const StyledChipIcon = styled('img')({
    margin: 'auto',
    height: '16px',
})
